export const NAVIGATION_ITEMS = {
    "/about": { id: "/about", label: "Über uns", path: "/about" },
    "/settings": { id: "/settings", label: "Einstellungen", path: "/settings", requiresRoles: ["ADMIN"] },
    "/appointments": { id: "/appointments", label: "Gebuchte Termine", path: "/appointments" },
    "/appointments/new": { id: "/appointments/new", label: "Termin erfassen", path: "/appointments/new" },
    "/calendar": { id: "/calendar", label: "Kalender", path: "/calendar" },
    "/customers": { id: "/customers", label: "Kunden", path: "/customers" },
    "/supply/invoices": { id: "/supply/invoices", label: "Rechnungsprüfung", path: "/supply/invoices" },
    "/devops/monitoring": { id: "/devops/monitoring", label: "DevOps", path: "/devops/monitoring" },
    "/vehicles": { id: "/vehicles", label: "Kundenfahrzeuge", path: "/vehicles" },
    "/inventory": { id: "/inventory", label: "Lager", path: "/inventory" },
    "/work-orders": { id: "/work-orders", label: "Aufträge", path: "/work-orders" },
    "/announcement": { id: "/announcement", label: "Ankündigung", path: "/announcement" },
    "/feedback": { id: "/feedback", label: "Feedback", path: "/feedback" },
    "/opening-times": { id: "/opening-times", label: "Öffnungszeiten", path: "/opening-times" },
    "/admin/users": { id: "/admin/users", label: "Benutzer", path: "/admin/users" },
    "/admin/cars": { id: "/admin/cars", label: "Fahrzeugverkauf", path: "/admin/cars" },
    "/admin/services": { id: "/admin/services", label: "Services", path: "/admin/services" },
    "/vacations": { id: "/vacations", label: "Urlaub", path: "/vacations" },
};

export const TOP_NAVIGATION_ITEMS = ["/about", "/settings"];

export const ROLE_NAVIGATION_MENUS = {
    ADMIN: {
        label: "Admin",
        items: [
            "/appointments",
            "/appointments/new",
            "/calendar",
            "/customers",
            "/supply/invoices",
            "/devops/monitoring",
            "/vehicles",
            "/inventory",
            "/work-orders",
            "/announcement",
            "/feedback",
            "/opening-times",
            "/admin/users",
            "/admin/cars",
            "/admin/services",
            "/vacations",
        ],
    },
    DISPONENT: {
        label: "Disponent",
        items: [
            "/appointments",
            "/appointments/new",
            "/calendar",
            "/customers",
            "/supply/invoices",
            "/devops/monitoring",
            "/vehicles",
            "/inventory",
            "/work-orders",
        ],
    },
    LAGERIST: {
        label: "Lagerist",
        items: ["/inventory", "/supply/invoices", "/work-orders"],
    },
    MECHANIKER: {
        label: "Mechaniker",
        items: ["/vehicles", "/work-orders", "/calendar"],
    },
};

export function getAllNavigationItemIds() {
    return Object.keys(NAVIGATION_ITEMS);
}

export function getOrderedNavigationItemsForSettings() {
    const topItems = TOP_NAVIGATION_ITEMS.map((id) => NAVIGATION_ITEMS[id]).filter(Boolean);
    const remaining = Object.values(NAVIGATION_ITEMS)
        .filter((item) => !TOP_NAVIGATION_ITEMS.includes(item.id))
        .sort((a, b) => a.label.localeCompare(b.label, "de"));
    return [...topItems, ...remaining];
}
